var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8148 2.38896C12.9611 3.58626 13.6654 5.21024 13.6654 6.9987C13.6654 10.6806 10.6806 13.6654 6.9987 13.6654C3.3168 13.6654 0.332031 10.6806 0.332031 6.9987C0.332031 3.3168 3.3168 0.332031 6.9987 0.332031C8.81088 0.332031 10.4542 1.05509 11.6559 2.22844C11.7097 2.28105 11.7627 2.33456 11.8148 2.38896ZM12.332 6.9987C12.332 9.94422 9.94422 12.332 6.9987 12.332C4.05318 12.332 1.66536 9.94422 1.66536 6.9987C1.66536 4.16515 3.87509 1.84771 6.6653 1.67562C6.84905 1.66428 6.9987 1.8146 6.9987 1.9987V6.42135C6.9987 6.67795 7.27648 6.83832 7.4987 6.71002L11.3299 4.4981C11.4892 4.40611 11.6939 4.46017 11.7759 4.62486C12.1319 5.33977 12.332 6.14586 12.332 6.9987Z",
    fill: "#161A1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.c58db75861bef44452bb6c168b4602a7.svg";
export { ForwardRef as ReactComponent };